import React, { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Polls for new notifications and pops a toast when a fresh one arrives (web
// equivalent of the mobile LiveNotifier).
export function LiveNotifier() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const seen = useRef(null);
  const first = useRef(true);

  useQuery({
    queryKey: ["live-notifier"],
    enabled: !!user,
    refetchInterval: 15000,
    queryFn: async () => {
      const s = await apiFetch("/notifications/summary");
      const latest = s?.latest;
      if (latest && latest.id !== seen.current) {
        if (!first.current) {
          toast(latest.text, {
            action: latest.link
              ? { label: "View", onClick: () => navigate(latest.link) }
              : undefined,
          });
        }
        seen.current = latest.id;
      }
      first.current = false;
      return s;
    },
  });

  return null;
}
